/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Fresh_Crab_PlayInputs */

const en_wide_fresh_crab_play = /** @type {(inputs: Wide_Fresh_Crab_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employee-Id`)
};

const de_wide_fresh_crab_play = /** @type {(inputs: Wide_Fresh_Crab_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalnummer`)
};

/**
* | output |
* | --- |
* | "Employee-Id" |
*
* @param {Wide_Fresh_Crab_PlayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_fresh_crab_play = /** @type {((inputs?: Wide_Fresh_Crab_PlayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Fresh_Crab_PlayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_fresh_crab_play(inputs)
	return de_wide_fresh_crab_play(inputs)
});